/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // ───────────────────────────────────────────────────────────────────────────
  // Fast cart-drawer open on Add to Cart
  // ───────────────────────────────────────────────────────────────────────────
  //
  // Stock Broadcast opens the drawer from `theme:product:added`, which runs only
  // after GET /cart?section_id=api-cart-items finishes — extra delay while the
  // section HTML renders.
  //
  // Listen to `theme:product:add` instead: the theme dispatches it only after
  // POST /cart/add.js succeeds, so the line item is in the cart before we open.
  // The heavy GET + `build()` still runs in the background (loading state in
  // the drawer until contents update).
  //
  // Flow (theme.dev.js): POST ok → `theme:product:add` → open drawer here →
  // getCart() → `theme:product:added` (drawer already open; no double-open).

  document.addEventListener('theme:product:add', function (event) {
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'drawer') {
      return;
    }

    var button = event.detail && event.detail.button;
    if (!button) return;

    if (button.closest('cart-drawer')) return;

    if (button.closest('[data-quick-add-modal]')) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer.classList.contains('is-open')) return;

    drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
  });
})();



function openLast(cl) {
  console.log(openLast,"openLast")
  const el = document.querySelector(`#${cl}`);
  if (el) el.click();
}